import { useCallback } from "react";
import {
  useAddFieldValidation
} from "../../core/hooks/useAddFieldValidation/useAddFieldValidation.js";
function useIsFieldRequired(fieldName, options) {
  const { checkIsEmpty, message, ...addFieldValidationOptions } = options ?? {};
  const validator = useCallback(
    (field) => {
      const value = field.value;
      const isEmpty = checkIsEmpty ? checkIsEmpty(value) : value === void 0 || value === null ? true : typeof value === "string" ? value.trim().length === 0 : Array.isArray(value) ? value.length === 0 : typeof value === "object" ? Object.keys(value).length === 0 : (
        /* v8 ignore next 1 */
        false
      );
      return field.required && isEmpty;
    },
    [checkIsEmpty]
  );
  const errorMessage = message ?? `The field "${fieldName.toString()}" is required, it cannot be empty.`;
  return useAddFieldValidation(fieldName, validator, {
    ...addFieldValidationOptions,
    message: errorMessage
  });
}
export {
  useIsFieldRequired
};
//# sourceMappingURL=useIsFieldRequired.js.map
